import { NullableFooterNavigation } from './footer';
import { NullableMenuNavigation } from './navigationBar';
import { Section } from './section';
import { SlugEntity } from './slugEntity';
import { Tag } from './tag';

export type NullbalePage = Page | null;

export interface Page extends SlugEntity {
    canonical: string | null;
    title: string;
    description: string;
    englishTitle: string | null;
    entityType: number;
    parentPageId: number | null;
    footerNavigationId: number | null;
    menuNavigationId: number | null;
    prefixedImagePath: string;
    previewId: string;
    previewPageEnabled: boolean;
    previewPassword: string | null;
    sections: Section[] | null;
    menuNavigationDisabled: boolean;
    footerNavigationDisabled: boolean;
    mobileDemoBannerDisabled: boolean;
    isClientSideRedirect: boolean;
    breadcrumbDisabled: boolean;
    contentType: PageContentType | null;
    tags: Tag[];
    variants: string[] | null;
}

export type NullablePage = Page | null;

export interface PreviewPage {
    page: Page;
    navbar: NullableMenuNavigation;
    footer: NullableFooterNavigation;
}

export enum PageContentType {
    Podcast = 1,
    EBook = 2,
    Webinar = 3,
    Guides = 4,
    Tools = 5,
}

export type PageKeys = keyof Page;
